// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"ResponsiveGallery__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ResponsiveGallery/ResponsiveGallery.scss
 ** module id = 931
 ** module chunks = 1
 **/